<script type="ts">
  import PlayerChip from "./PlayerChip.svelte";
  export let players;
  export let onChangeUserIcon = null;
  export let onDeleteUser = null;
  export let centered = true;
</script>

<div
  class="flex flex-wrap items-center mt-3 overflow-x-scroll {centered
    ? 'justify-center'
    : 'justify-start'}"
>
  {#each players as player}
    <PlayerChip {player} {onChangeUserIcon} {onDeleteUser} />
  {/each}
</div>
